import { Component } from '@angular/core';

@Component({
  selector: 'unauthorized-access',
  template: '<h1>{{"common.unauthorizedAccess" | translate}}</h1>',
  standalone: false,
})
export class UnauthorizedAccessComponent {}
